export const CONSULT_URL = 'https://wowdigital.com/consult/?ref=ROI-Calculator';